import { render, staticRenderFns } from "./ReportListBody.vue?vue&type=template&id=0bc7fade"
import script from "./ReportListBody.vue?vue&type=script&lang=js"
export * from "./ReportListBody.vue?vue&type=script&lang=js"
import style0 from "./ReportListBody.vue?vue&type=style&index=0&id=0bc7fade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports